import React, { useState, useEffect, Fragment } from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import Step1 from './Step1';
import Step2 from './Step2';
import { getEmployeeAdmin } from "../../../helpers/api_rombo_helper";
import Instructions from './Instructions';
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import AlertError from "../../../components/Alerts/AlertError";
import { orgId } from "../../../constants/utils";

const EditEmployee = (props) => {
  document.title = `${i18n.t("EmployeeEdit")} - ${orgId}`;

  const dispatch = useDispatch();
  const { id } = useParams();
  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState("");
  const [name, setName] = useState("");
  const [depot, setDepot] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] });
  const [selectedAddress, setSelectedAddress] = useState({});
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [newAddresses, setNewAddresses] = useState([]);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    onGetEmployeeAdmin();
  }, [dispatch]);

  useEffect(() => {
    if (data?.data) {
      setInfoUser(data.data);
    }
  }, [dispatch, data, loading]);

  const onGetEmployeeAdmin = () => {
    getEmployeeAdmin(token, id)
      .then((response) => {
        setSelectedEmployee(response);
        setCompany({ label: response.company_name, value: response.company_id });
        setIdentifier(response.identifier);
        setName(response.name);
        setDepot(response.depot);
        setPhone(response.phone);
        setEmail(response.email);
      })
      .catch((error) => {
        console.error("Error - getEmployeeAdmin - ", error);
      });
  };

  const switchStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            setStep={setStep}
            step={step}
            token={token}
            setIdentifier={setIdentifier}
            setName={setName}
            setDepot={setDepot}
            setEmail={setEmail}
            setPhone={setPhone}
            setCompany={setCompany}
            identifier={identifier}
            name={name}
            depot={depot}
            email={email}
            phone={phone}
            company={company}
            infoUser={infoUser}
            setErrorAlert={setErrorAlert}
            setErrorAlertMessage={setErrorAlertMessage}
          />
        );
      case 2:
        return (
          <Step2
            token={token}
            step={step}
            selectedEmployee={selectedEmployee}
            setStep={setStep}
            setAddresses={setAddresses}
            setSelectedAddress={setSelectedAddress}
            setNewAddresses={setNewAddresses}
            newAddresses={newAddresses}
            selectedAddress={selectedAddress}
            identifier={identifier}
            name={name}
            email={email}
            depot={depot}
            phone={phone}
            company={company}
            infoUser={infoUser}
            setErrorAlert={setErrorAlert}
            setErrorAlertMessage={setErrorAlertMessage}
          />
        );
      default:
        break;
    }
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink
            title={i18n.t("Employees")}
            link={'/employees'}
            breadcrumbItem={i18n.t("EmployeeEdit")}
          />
          <Row>
            <Card>
              <CardBody>
                <Instructions step={step} />
              </CardBody>
            </Card>
          </Row>
          <Col xxl={12} md={12} xs={12} className="">
            <AlertError
              showAlertError={errorAlert}
              setShowAlertError={setErrorAlert}
              textHeader={i18n.t("Error")}
              textBody={errorAlertMessage}
            />
          </Col>
          <div className="container-fluid">
            <Row>
              <Card>
                {switchStep()}
              </Card>
            </Row>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditEmployee;
